import { Quote } from 'lucide-react';
import { testimonials } from '../mock';

export default function Testimonials() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-4">
            — Voices from the field
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] leading-[1.05]">
            Trusted by industry leaders across India.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className="card-lift relative rounded-2xl border border-neutral-200 bg-neutral-50/60 p-8 flex flex-col"
            >
              <Quote className="h-8 w-8 text-amber-500 mb-4" />
              <blockquote className="text-neutral-800 leading-relaxed text-[15px] flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-6 border-t border-neutral-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-sm text-[#0b0b0d]">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
